import React, { useEffect, FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import Analytics from "ANALYTICS/index";
import ExperienceOffline from "Components/helpers/ExperienceOffline";
import PageLoader from "Components/loader/pageLoader";
import PageNotFound from "Components/helpers/PageNotFound";
import { GeneralError } from "Components/helpers";
import { IRootState } from "../../../store/rootState";

interface Props {
  children: any;
}

const YouVisitAnalytics: FC<any> = ({ children }: Props) => {
  const dispatch = useDispatch();
  const tourModel = useSelector((state: IRootState) => state.tour);
  const analyticsModel = useSelector((state: IRootState) => state.analytics);
  useEffect(() => {
    Analytics.YouVisitAnalytics.init(
      tourModel.instId,
      tourModel.locId,
      tourModel.tourid,
      tourModel.platform,
      dispatch
    );
  }, [dispatch, tourModel]);

  // Are we still parsing data to set redux?
  if (!analyticsModel || !analyticsModel.isReady) return <PageLoader />;
  if (!tourModel || !tourModel.instId)
    return <GeneralError message="Failed to initialize form configuration." />;
  if (analyticsModel.isExperienceOffline) {
    return <ExperienceOffline />;
  }
  if (analyticsModel.isExperienceNotFound) {
    return <PageNotFound />;
  }
  return children;
};

export default YouVisitAnalytics;
